export class Jwt {
    private token: string;
  
    constructor(token: string) {
      this.token = token;
    }
  
    decode<T = any>(): T | null {
      try {
        const payload = this.token.split(".")[1];
        if (!payload) return null;
  
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
  
        return JSON.parse(json) as T;
      } catch {
        return null;
      }
    }
  
    isExpired(): boolean {
      const payload = this.decode<{ exp?: number }>();
      if (!payload?.exp) return true;
  
      return payload.exp * 1000 < Date.now();
    }
  
    getToken(): string {
      return this.token;
    }
  }
  